import React from "react";

const WalletWhiteSmall = ({ fill }) => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.25 4.5C2.25 3.90326 2.48705 3.33097 2.90901 2.90901C3.33097 2.48705 3.90326 2.25 4.5 2.25H17.0625C17.709 2.25 18.329 2.50681 18.7861 2.96393C19.2432 3.42105 19.5 4.04103 19.5 4.6875V5.442C20.811 5.9055 21.75 7.15575 21.75 8.625V18.375C21.75 19.2701 21.3944 20.1285 20.7615 20.7615C20.1286 21.3944 19.2701 21.75 18.375 21.75H5.625C4.7299 21.75 3.87145 21.3944 3.23852 20.7615C2.60558 20.1285 2.25 19.2701 2.25 18.375V4.6875H2.2575C2.25243 4.62513 2.24993 4.56258 2.25 4.5ZM18 4.6875C18 4.17 17.58 3.75 17.0625 3.75H4.5C4.30109 3.75 4.11032 3.82902 3.96967 3.96967C3.82902 4.11032 3.75 4.30109 3.75 4.5C3.75 4.69891 3.82902 4.88968 3.96967 5.03033C4.11032 5.17098 4.30109 5.25 4.5 5.25H18V4.6875ZM15.75 13.5C15.5511 13.5 15.3603 13.579 15.2197 13.7197C15.079 13.8603 15 14.0511 15 14.25C15 14.4489 15.079 14.6397 15.2197 14.7803C15.3603 14.921 15.5511 15 15.75 15H18C18.1989 15 18.3897 14.921 18.5303 14.7803C18.671 14.6397 18.75 14.4489 18.75 14.25C18.75 14.0511 18.671 13.8603 18.5303 13.7197C18.3897 13.579 18.1989 13.5 18 13.5H15.75Z"
				fill={fill}
			/>
		</svg>
	);
};

export default WalletWhiteSmall;
